// theme.js — header, nav, drawer toggles, accessibility utilities.
// No framework. Plain modules. Loaded once with `defer`.

(() => {
  'use strict';

  /* ---------- Mobile menu ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const menuClose = document.querySelector('[data-menu-close]');

  function openMenu() {
    if (!mobileDrawer) return;
    mobileDrawer.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    mobileDrawer.querySelector('a, button')?.focus();
  }
  function closeMenu() {
    if (!mobileDrawer) return;
    mobileDrawer.removeAttribute('open');
    document.body.style.overflow = '';
    menuToggle?.focus();
  }

  menuToggle?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (mobileDrawer?.hasAttribute('open')) closeMenu();
    }
  });

  /* ---------- Header shadow on scroll ---------- */
  const header = document.querySelector('.site-header');
  if (header) {
    const setShadow = () => header.classList.toggle('site-header--scrolled', window.scrollY > 8);
    setShadow();
    window.addEventListener('scroll', setShadow, { passive: true });
  }

  /* ---------- Lazy hero video ---------- */
  document.querySelectorAll('video[data-lazy]').forEach((v) => {
    new IntersectionObserver((entries, obs) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          v.src = v.dataset.src;
          v.load();
          obs.disconnect();
        }
      });
    }, { rootMargin: '200px' }).observe(v);
  });

  /* ---------- Klaviyo form submission analytics hook ----------
     Klaviyo handles its own form rendering. We listen for the
     KlaviyoSubscribe event to fire GA4 and Meta Pixel events. */
  window.addEventListener('klaviyoForms', (e) => {
    if (e.detail?.type === 'submit') {
      window.dataLayer?.push({ event: 'waitlist_signup', source: e.detail?.formId });
      window.fbq?.('track', 'CompleteRegistration');
    }
  });

  /* ---------- Smooth anchor offsets for sticky header ---------- */
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href').slice(1);
      const target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      const headerH = header?.offsetHeight || 0;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - headerH - 16, behavior: 'smooth' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  });
})();
